import React from 'react'
import { useDropzone } from 'react-dropzone'
import { Upload } from 'react-feather'
import { File as FileIcon, Trash2 } from 'react-feather'
import './planilhaUploadCard.scss'

export function PlanilhaUploadCard({
  fileName,
  contactCount = 0,
  fileError = '',
  onDropAccepted,
  onClear,
  disabled = false
}) {
  const { getRootProps, getInputProps, isDragActive, isFocused } = useDropzone({
    onDrop: onDropAccepted,
    maxSize: 100000000,
    multiple: false,
    accept: ['.xlsx'],
    disabled
  })

  const rootProps = getRootProps({
    className: [
      'planilha-upload-card__zone',
      isDragActive && 'planilha-upload-card__zone--drag',
      isFocused && 'planilha-upload-card__zone--focus',
      fileError && 'planilha-upload-card__zone--error',
      disabled && 'planilha-upload-card__zone--disabled'
    ]
      .filter(Boolean)
      .join(' ')
  })

  return (
    <div className="planilha-upload-card">
      <div {...rootProps}>
        <input {...getInputProps()} />
        <Upload
          className="planilha-upload-card__upload-ico"
          size={36}
          strokeWidth={1.5}
          aria-hidden
        />
        <p className="planilha-upload-card__primary">
          Arraste o arquivo aqui ou{' '}
          <span className="planilha-upload-card__browse">clique para selecionar</span>
        </p>
        <p className="planilha-upload-card__secondary">Apenas arquivos .xlsx</p>
      </div>

      {fileError ? (
        <p className="planilha-upload-card__error" role="alert">
          {fileError}
        </p>
      ) : null}

      {fileName ? (
        <div className="planilha-upload-card__file planilha-upload-card__file--success">
          <FileIcon className="planilha-upload-card__file-icon flex-shrink-0" size={20} />
          <div className="planilha-upload-card__file-meta">
            <span className="planilha-upload-card__file-name text-truncate" title={fileName}>
              {fileName}
            </span>
            <span className="planilha-upload-card__file-count">
              {contactCount}{' '}
              {contactCount === 1 ? 'contato encontrado' : 'contatos encontrados'}
            </span>
          </div>
          <button
            type="button"
            className="planilha-upload-card__remove"
            onClick={(e) => {
              e.stopPropagation()
              onClear()
            }}
            aria-label="Remover arquivo"
            disabled={disabled}
          >
            <Trash2 size={18} />
          </button>
        </div>
      ) : null}
    </div>
  )
}
